import { FieldValidator } from 'formik';

export const phoneRegexp = /^\d{10}$/;
export const birthdateRegexp = /^\d{8}$/;
export const passwordRegex = /^[A-Za-zА-Яа-яЁё\d`!@#$%^&*()\/\\{}\[\]’;:,<>?~”№=+"'\-_]{8,16}$/;

export const composeValidators =
  (validators: FieldValidator[]): FieldValidator =>
  (value) => {
    const errors = validators.map((validator) => validator(value)).filter((value) => !!value);
    if (errors.length) return errors[0];
    return undefined;
  };
export const required =
  (message?: string): FieldValidator =>
  (value) => {
    if (!value) return message || 'Обязательное поле';
  };
export const pattern =
  (regexp: RegExp, message?: string): FieldValidator =>
  (value) => {
    return !!value && !regexp.test(value) ? message || "Неверный формат" : undefined;
  };
